<template>
  <div class="copyright">
    <div v-if="lang.lang === 'en'">
      BigdealAgency © 2015-{{ currentYear || '2022' }}
      <br>
      TecophoneLTD: Registered address: Kypranoros, 13 EVI BUILDING, 2nd floor, office 201, 1061, Nicosia, Cyprus
      <div>
        <a href="https://www.cgbilling.com/secure" target="_blank" >www.CommerceGate.com</a> payment support
      </div>
      <div>
        Please visit <a href="https://www.commercegate.com" target="_blank">CommerceGate</a>, our authorized sales agent
      </div>
    </div>

    <div v-if="lang.lang === 'ru'" class="ru">
      BigdealAgency © 2015-{{ currentYear || '2022' }}
      <br>
      TecophoneLTD: Юридический адрес: Kypranoros, 13 EVI BUILDING, 2nd floor, office 201, 1061, Nicosia, Cyprus
      <div>
        <a href="https://www.cgbilling.com/secure" target="_blank">www.CommerceGate.com</a> служба поддержки платежей, <a href="https://www.commercegate.com" target="_blank">CommerceGate</a> наш авторизированный поставщик платёжных услуг
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyRight',

  props: { lang: Object },

  data:() => {
    return {
      currentYear: '2022',
    }
  },

  mounted: function() {
    this.currentYear = new Date().getFullYear();
  },
}
</script>

<style>
.copyright {
    max-width: 360px;
    font-size: 11px;
    padding-right: 40px;
}

.copyright .ru {
    font-size: 10px;
}

@media (max-width: 1023px) {
  .copyright {
    max-width: 279px;
    font-size: 8px;
    padding-right: 10px;
  }
}
</style>


